//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapMutations} from "vuex";
import FieldAnalysis from "./FieldAnalysis";
import {analysis} from "@/constants";

export default {
  name: "SelectFieldsStep",
  components: {
    FieldAnalysis
  },

  data() {
    return {
      search: null,
      loading: true,
      expand: {},
      properties: [],
      searched: [],
      statistics: []
    };
  },

  watch: {
    statistics() {
      this.searched = this.statistics;
    }
  },

  computed: {
    ...mapGetters(["newModel"])
  },

  methods: {
    ...mapMutations({
      setNewModel: "setNewModel",
      setShowFieldEdit: "setShowFieldEdit",
      editFieldData: "editFieldData"
    }),

    disableField(item) {
      return !!this.newModel.selectedPredictionProperties.find(p => p.field === item.field);
    },

    expandCell(obj) {
      if (this.expand[obj.field] === undefined || !this.expand[obj.field]) {
        this.$set(this.expand, obj.field, true);
      } else {
        this.$set(this.expand, obj.field, false);
      }
    },

    editField(item) {
      this.editFieldData(item);
      this.setShowFieldEdit(true);
    },

    updateSelectedProperties(selection) {
      const tmpModel = Object.assign({}, this.newModel);
      tmpModel.selectedFieldsProperties = selection;
      this.setNewModel(tmpModel);
    },

    searchOnTable() {
      this.searched = this.searchByName(this.statistics, this.search);
    },

    searchByName(items, term) {
      if (term) {
        return items.filter(item =>
            this.toLower(item.field).includes(this.toLower(term))
        );
      }
      this.searched = this.statistics;
      return this.searched;
    },

    toLower(term) {
      return term.toString().toLowerCase();
    },

    dotClass(severity) {
      switch (severity) {
        case analysis.FATAL:
          return "red";
        case analysis.WARNING:
          return "orange";
        case analysis.NONE:
          return "green";
        default:
          break;
      }
    }
  }
};
